import React, { useContext } from "react";
import SwitchShipToPage from "Components/common/SwitchShipToPage";
import {
  getSTAddress,
  validateContact,
  isValidChinesePhoneWithCountryCode,
} from "../../utils/addressUtils";
import { Dropdown } from "antd";
import { USER_TYPE } from "../../utils/constant";
import { AppContext } from "../../store";

const ShippingAddress: React.FC<{
  errMsg?: string;
  setErrMsg: (value: string) => void;
  selectedST: any;
  stContact: string;
  setStContact: (value: string) => void;
  showSTSelector: boolean;
  setShowSTSelector: (value: boolean) => void;
  onSTClick: (value: any) => void;
  [key: string]: any;
}> = (props) => {
  const { loginState } = useContext(AppContext);
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const {
    stContact,
    setStContact,
    selectedST,
    errMsg,
    setErrMsg,
    showSTSelector,
    setShowSTSelector,
    onSTClick,
  } = props;
  const handleContact = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    setStContact(e.target.value);
    const res = validateContact(e.target.value);
    if (res?.isValid) {
      const phoneRaw = res.value.split(",")[1] || "";
      const phone = phoneRaw.replace(/[()\uFF08\uFF09]/g, "").trim(); // 兼容中英文括号
      if (phone && !isValidChinesePhoneWithCountryCode(phone)) {
        setErrMsg("注意：您输入的联系方式格式可能不对，若您确认无误，请忽略");
      } else {
        setErrMsg("");
      }
    } else {
      setErrMsg(res?.errMsg || "注意：您输入的联系方式格式可能不对，若您确认无误，请忽略");
    }
  };
  if (!selectedST) {
    return null;
  }
  const tagClass = selectedST?.isDefault ? "tag info" : "tag";
  return (
    <div className="card">
      <div>
        <span className="cardTitle">收货地址</span>
        {!isEmployee && (
          <Dropdown
            trigger={["click"]}
            open={showSTSelector}
            placement="bottomRight"
            dropdownRender={(node) => {
              console.log("node", node);
              return (
                <div className="addrSelectorWrapper">
                  <SwitchShipToPage
                    page="Order_Confirmation"
                    onSTClick={onSTClick}
                    showSwitchStPage={showSTSelector}
                    setShowSwitchStPage={setShowSTSelector}
                  />
                </div>
              );
            }}
            onOpenChange={(open) => {
              console.log("dropdown open", open);
              if (!open) {
                setShowSTSelector(false);
              }
            }}
          >
            <span
              className="textLink"
              style={{
                fontSize: "14px",
                lineHeight: "22px",
                marginLeft: "10px",
              }}
              onClick={() => {
                setShowSTSelector(true);
              }}
            >
              更改
            </span>
          </Dropdown>
        )}
      </div>
      {selectedST?.accountNumber && (
        <div className="gap8 subBlock">
          {selectedST?.isDefault && <span className={tagClass}>{"默认"}</span>}
          <span className="label">账户</span>
          <span className="text">{selectedST?.accountNumber}</span>
        </div>
      )}
      {!selectedST?.accountNumber && (
        <div className="gap8 subBlock">
          <span className="label">web参考号</span>
          <span className="text">{selectedST?.addressKey}</span>
        </div>
      )}
      <div className="block2 labelTextLine">
        <label className="primaryLabel">收货单位</label>{" "}
        <span className="primaryText">{selectedST?.companyOrInstitution}</span>
      </div>
      <div className="gap12 labelTextLine">
        <label className="primaryLabel">收货地址</label>{" "}
        <span className="primaryText">{getSTAddress(selectedST)}</span>
      </div>
      <div className="block3">
        <label className="primaryLabel">
          收货联系人+电话（必填）（格式: 姓名,电话）
        </label>
      </div>
      <div className="gap8">
        <input
          className={errMsg ? "input err" : "input"}
          value={stContact}
          maxLength={50}
          onChange={handleContact}
        ></input>
      </div>
      <div className="errWrapper">{errMsg || ""}</div>
    </div>
  );
};

export default ShippingAddress;
